<template>
  <v-text-field
    :disabled="disabled"
    v-model.number="quantity"
    class="quantity"
    height="50"
    @change="change"
  >
    <v-icon
      slot="prepend"
      :disabled="disabled || !canDecrement"
      size="40"
      color="primary"
      class="icon-position"
      @click="decrement"
    >
      indeterminate_check_box
    </v-icon>
    <v-icon
      slot="append-outer"
      :disabled="disabled || !canIncrement"
      size="40"
      color="primary"
      class="icon-position"
      @click="increment"
    >
      add_box
    </v-icon>
  </v-text-field>
</template>

<script>
export default {
  name: 'OrderDraftItemQuantity',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    value: {
      type: Number,
      default: undefined
    },

    min: {
      type: Number,
      default: 1
    },

    max: {
      type: Number,
      default: null
    }
  },

  computed: {
    canIncrement () {
      if (!this.max) {
        return true
      }

      return this.quantity < this.max
    },

    canDecrement () {
      return this.quantity > this.min
    },

    quantity: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  watch: {
    min: function () {
      if (this.current && this.current > this.min) {
        return
      }

      this.quantity = this.min
    }
  },

  mounted () {
    this.quantity = this.value || this.min
  },

  methods: {
    change (val) {
      val = parseInt(val)

      if (val > this.max) {
        this.changeQuantity(this.max)
        return
      }

      if (val < this.min) {
        this.changeQuantity(this.min)
        return
      }

      this.changeQuantity(isNaN(val) ? 1 : val)
    },

    increment () {
      if (!this.canIncrement) {
        return
      }

      this.quantity++
    },

    decrement () {
      if (!this.canDecrement) {
        return
      }

      this.quantity--
    },

    changeQuantity (val) {
      this.quantity = val
    }
  }
}
</script>

<style>
.quantity input {
  padding-bottom: 2px;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
}
</style>
